export default {"src":"/_next/static/media/cicon1.10422187.svg","height":56,"width":51};